import type { SessionStorageGateway } from '@/application/port/out/SessionStorageGateway';
import type { AuthSession } from '@/domain/model/User';

const REFRESH_KEY = 'ava.auth.refreshToken';
const SESSION_KEY = 'ava.auth.session';

/**
 * Impl localStorage do SessionStorageGateway. Refresh token e session leve
 * (cold-start) persistem; access token NUNCA persiste (vive em memória Pinia).
 */
export class LocalSessionStorage implements SessionStorageGateway {
  saveRefreshToken(token: string): void {
    try {
      localStorage.setItem(REFRESH_KEY, token);
    } catch {
      /* private mode etc — silencioso */
    }
  }

  loadRefreshToken(): string | null {
    try {
      return localStorage.getItem(REFRESH_KEY);
    } catch {
      return null;
    }
  }

  saveSession(session: AuthSession): void {
    try {
      const slim: Omit<AuthSession, 'accessToken'> = {
        refreshToken: session.refreshToken,
        accessExpiresAt: session.accessExpiresAt,
        user: session.user,
      };
      localStorage.setItem(SESSION_KEY, JSON.stringify(slim));
    } catch {
      /* idem */
    }
  }

  loadSession(): AuthSession | null {
    try {
      const raw = localStorage.getItem(SESSION_KEY);
      if (!raw) return null;
      const slim = JSON.parse(raw) as Omit<AuthSession, 'accessToken'>;
      // Access token é null no cold-start; primeiro request 401 → refresh.
      return { ...slim, accessToken: '' };
    } catch {
      return null;
    }
  }

  clear(): void {
    try {
      localStorage.removeItem(REFRESH_KEY);
      localStorage.removeItem(SESSION_KEY);
    } catch {
      /* idem */
    }
  }
}
